export default "__VITE_ASSET__bHWuiXmT__"